import { render, staticRenderFns } from "./OnlineModelManage.vue?vue&type=template&id=1452ad63&"
import script from "./OnlineModelManage.vue?vue&type=script&lang=js&"
export * from "./OnlineModelManage.vue?vue&type=script&lang=js&"
import style0 from "./OnlineModelManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports